const Type = ['diagram', 'mindmap'];
function findDiagramNode(root: any) {
    if (Type.includes(root.type)) {
        return root;
    }
    if (!Array.isArray(root.children)) {
        return;
    }
    for (const node of root.children) {
        if (Type.includes(root.type)) {
            return node;
        }
        const result: any = findDiagramNode(node);
        if (result) {
            return result;
        }
    }

    return null;
}

// 遍历树的数组
export function findFirstDiagramInTrees(trees: any[]) {
    if (!Array.isArray(trees)) {
        return;
    }
    for (const tree of trees) {
        const result = findDiagramNode(tree);
        if (result) {
            return result;
        }
    }
}
